module.exports = ".share-facebook, .share-pinterest {\n  cursor: pointer; }\n  .share-facebook img, .share-pinterest img {\n    width: 20px; }\n  .disabled {\n  cursor: not-allowed; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/visualizer/share-project/share-project.component.scss
// module id = ./src/app/components/visualizer/share-project/share-project.component.scss
// module chunks = main